import { SchemaUnionsKey } from 'gqty';
export const scalarsEnumsHash = {
    Any: true,
    Boolean: true,
    Date: true,
    File: true,
    Float: true,
    ID: true,
    Int: true,
    JSON: true,
    JSONObject: true,
    Number: true,
    String: true,
    Void: true
};
export const generatedSchema = {
    DriverInfo: {
        __typename: { __type: 'String!' },
        configured: { __type: 'Boolean!' },
        isDefault: { __type: 'Boolean!' },
        name: { __type: 'String!' }
    },
    GitStatus: {
        __typename: { __type: 'String!' },
        branch: { __type: 'String!' },
        head: { __type: 'String' },
        remote: { __type: 'String' },
        root: { __type: 'String!' }
    },
    IStoredFile: {
        __typename: { __type: 'String!' },
        file_id: { __type: 'String!' },
        file_name: { __type: 'String' },
        file_size: { __type: 'Number' },
        file_unique_id: { __type: 'String!' },
        mime_type: { __type: 'String' },
        thumb: { __type: 'Thumb' },
        $on: { __type: '$IStoredFile!' }
    },
    StoredFile: {
        __typename: { __type: 'String!' },
        file_id: { __type: 'String!' },
        file_name: { __type: 'String' },
        file_size: { __type: 'Number' },
        file_unique_id: { __type: 'String!' },
        mime_type: { __type: 'String' },
        thumb: { __type: 'Thumb' }
    },
    StoredFileArgsInput: { id: { __type: 'String!' } },
    Thumb: {
        __typename: { __type: 'String!' },
        file_id: { __type: 'String!' },
        file_size: { __type: 'Number' },
        file_unique_id: { __type: 'String!' },
        height: { __type: 'Number' },
        width: { __type: 'Number' }
    },
    UploadArgsInput: { driver: { __type: 'String' }, file: { __type: 'File!' } },
    UploadResult: {
        __typename: { __type: 'String!' },
        driver: { __type: 'String!' },
        file_id: { __type: 'String!' },
        file_name: { __type: 'String' },
        file_size: { __type: 'Number' },
        file_unique_id: { __type: 'String!' },
        mime_type: { __type: 'String' },
        thumb: { __type: 'Thumb' },
        thumbUrl: { __type: 'String' },
        url: { __type: 'String!' }
    },
    mutation: {
        __typename: { __type: 'String!' },
        upload: { __type: 'UploadResult!', __args: { args: 'UploadArgsInput!' } }
    },
    query: {
        __typename: { __type: 'String!' },
        gitStore: { __type: 'GitStatus!' },
        storageDrivers: { __type: '[DriverInfo!]!' },
        storedFile: {
            __type: 'UploadResult',
            __args: { args: 'StoredFileArgsInput!' }
        }
    },
    subscription: {},
    [SchemaUnionsKey]: { IStoredFile: ['StoredFile', 'UploadResult'] }
};
